import GetSpark from './GetSpark';

export default GetSpark;
